import { render, staticRenderFns } from "./InstagramMenu.vue?vue&type=template&id=3e8cb250"
import script from "./InstagramMenu.vue?vue&type=script&lang=js"
export * from "./InstagramMenu.vue?vue&type=script&lang=js"
import style0 from "./InstagramMenu.vue?vue&type=style&index=0&id=3e8cb250&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports